import { Link } from "react-router-dom";
import { ArrowUpRight, Mail } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { IMG, SITE } from "@/data/site";
import { useLang } from "@/i18n/LanguageContext";

export const CtaBand = () => {
  const { t } = useLang();
  return (
  <section className="px-6 pb-24 lg:px-10 lg:pb-32" data-testid="cta-section">
    <Reveal className="relative mx-auto max-w-7xl overflow-hidden rounded-[32px] bg-[var(--red)] text-white">
      <img src={IMG.greenChilies} alt="" className="absolute inset-0 h-full w-full object-cover opacity-30 mix-blend-multiply" />
      <div className="relative grid gap-10 p-10 lg:grid-cols-12 lg:p-16">
        <div className="lg:col-span-8">
          <p className="eyebrow !text-white/80">{t.cta.eyebrow}</p>
          <h2 className="font-display mt-4 text-3xl font-bold leading-[1] sm:text-4xl lg:text-5xl">{t.cta.title}</h2>
          <p className="mt-5 max-w-xl text-base text-white/85 md:text-lg">{t.cta.text}</p>
        </div>
        <div className="flex flex-col justify-end gap-3 lg:col-span-4 lg:items-end">
          <Link to="/contact" className="btn-pill bg-white text-[var(--red)] hover:bg-[var(--canvas)]" data-testid="cta-quote-btn">
            {t.cta.btn} <ArrowUpRight size={16} />
          </Link>
          <a href={`mailto:${SITE.email}`} className="btn-pill border border-white/40 hover:border-white" data-testid="cta-email-btn">
            <Mail size={16} /> {SITE.email}
          </a>
        </div>
      </div>
    </Reveal>
  </section>
  );
};
